import * as React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";

import { useMaterialUIController } from "../../context";
import { resetActiveQuiz, useUserController } from "../../context/user";
import Api from "../../Api/Api";
import { qr } from "../../constants";
import RenderCert from "./RenderCert";
import CircularProgress from "@mui/material/CircularProgress";
import colors from "../../colors";
import {Alert} from "@mui/material";

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  maxWidth: '98%',
  backgroundColor: colors.Theme.offWhite,
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

const Results = ({ data, cb, spanish, dis, score }) => {
  const navigate = useNavigate();
  const [controller] = useMaterialUIController();
  const [userController, userDispatch] = useUserController();
  const { user, activeQuiz } = userController;

  const [renderCert, setRenderCert] = React.useState(null);
  const [opened, setOpened] = React.useState(false);
  const [categoryTitle, setCategoryTitle] = React.useState('');
  const [emailLists, setEmailLists] = React.useState([]);
  const [eligibleLists, setEligibleLists] = React.useState([]);

  const handsOn = data.cat === 'f9eab94e-9e31-4d67-90cc-5ed40d2453f3';
  const template = process.env.REACT_APP_APP_INSTANCE === "CREWBELT" ? "template_c0s9ucl" : 'prod_template';


  React.useEffect(() => {
    Api.getOneQuiz(data.id).then(res => {
      setEligibleLists(res.data[0].listsUsed || []);
      return res.data[0].cat;
    }).then(categoryId => {
      Api.getOneCat(activeQuiz?.category || categoryId).then(res => {
        setCategoryTitle(res.data[0]?.title || '');
      });
    });
  }, [data.id, activeQuiz]);

  const handleOpen = async () => {
    const finalScore = await cb();
    setOpened(true);
    if (finalScore >= 70) await prepareCertificate(finalScore);
  };

  const handleClose = (backToVideo=false) => {
    setOpened(false);
    resetActiveQuiz(userDispatch);
    if(backToVideo) navigate(-1);
  };

  const getRecipientEmails = async () => {
    const allLists = await Api.getAllELists();
    const emails = [];

    allLists.data.forEach(list => {
      if (eligibleLists.includes(list.id)) {
        list.emails.forEach(email => {
          if (!list.isDeleted && !email.isDeleted) emails.push(email.email);
        });
      }
    });

    return emails.join(",");
  };

  const prepareCertificate = async (quizScore) => {
    const now = new Date();
    const formattedDate = `${now.getMonth() + 1}/${now.getDate()}/${now.getFullYear()}`;
    const timestamp = `${now.getMonth() + 1}${now.getDate()}${now.getFullYear()}${now.getHours()}${now.getMinutes()}${now.getSeconds()}`;

    const fullName = `${user.FirstName} ${user.LastName}`;
    const title = data.english.title;
    const userCookie = document.cookie;

    const emails = await getRecipientEmails();

    const params = {
      emp_name: fullName,
      emp_email: user.email,
      to_email: user.email,
      jobClassification: user.JobClassification,
      userID: userCookie?.userId || activeQuiz?.userId || user?.id,
      category: categoryTitle,
      metadata: { ...activeQuiz, id: data.id },
      certification_title: title,
      certificate_subtitle: data.certificate_subtitle,
      quiz_score: quizScore,
      todays_date: formattedDate,
      cert_name: `${title}-${timestamp}`,
      cert_url: '',
      specified_emails: emails ? `${emails},` : '',
      handsonqr: handsOn ? qr : null,
      handsonurl: handsOn
        ? 'https://forms.office.com/Pages/ResponsePage.aspx?id=GXqmInPrOkqJkwQaKPAWYMsuunUB6UBFv8qDuDebq_RURExQQzlYSUdKWkJaTFhLSTUyREM4MTE1QS4u&embed=true'
        : '',
    };

    setRenderCert(params);
  };

  const getResultMessage = () => {
    return spanish
      ? "La puntuación mínima para aprobar esta evaluación es 70. Vuelve a ver el video de formación y repite el cuestionario."
      : "The minimum passing score for this evaluation is 70. Please rewatch the training video and retake the quiz.";
  };

  return (
    <div>
      <Button variant="contained" onClick={handleOpen} disabled={dis}>
        {spanish ? "Enviar" : "Submit"}
      </Button>
      <Modal
        open={opened}
        onClose={() => handleClose(false)}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box sx={{ ...modalStyle, minHeight: 200, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
          {!renderCert ? (
            <>
              {/*<h2 id="modal-title" style={{display:"flex", marginBottom: 10}}><CircularProgress sx={{marginRight: 2}}/>{spanish ? "Evaluando" : "Evaluating"}</h2>*/}
              <Alert severity="error">{score >= 70
                ? spanish
                  ? "Evaluando tus resultados. Por favor, no cierres esta ventana."
                  : "Evaluating your results. Please do not close this window."
                : getResultMessage()}</Alert>
              <Box sx={{ width: '100%', display: "flex", justifyContent: "space-between", alignItems: "center", padding: 1, marginTop: 2}}>

                <Button variant="contained" onClick={() => handleClose(false)}>{spanish ? 'Intentar quiz otra vez' : 'Retry Quiz'}</Button>
                <Button variant="contained" onClick={() => handleClose(true)}>{spanish ? 'Volver al video' : 'Back to Video'}</Button>
              </Box>
              {/*<p style={{ textAlign: 'center' }}>*/}
              {/*  {score >= 70*/}
              {/*    ? spanish*/}
              {/*      ? "Evaluando tus resultados. Por favor, no cierres esta ventana."*/}
              {/*      : "Evaluating your results. Please do not close this window."*/}
              {/*    : getResultMessage()}*/}
              {/*</p>*/}
            </>
          ) : (
            <>
              <RenderCert data={renderCert} spanish={spanish} template={template} score={score} />
              <h2 id="modal-title">{spanish ? "Resultado" : "Result"}</h2>
              <p style={{ textAlign: 'center' }}>
                {spanish
                  ? `Has completado el cuestionario con una puntuación de ${score}.`
                  : `You have completed the quiz with a score of ${score}.`}
              </p>
              <Button style={{ marginTop: 20 }} variant="contained" onClick={handleClose}>
                {spanish ? "Salir" : "Exit"}
              </Button>
            </>
          )}
        </Box>
      </Modal>
    </div>
  );
};

Results.propTypes = {
  data: PropTypes.object.isRequired,
  cb: PropTypes.func.isRequired,
  spanish: PropTypes.bool,
  dis: PropTypes.bool,
  score: PropTypes.number.isRequired,
};

export default Results;
